interface GetFullNameArgs {
  firstName?: string;
  lastName?: string;
  userName?: string;
}

const getFullName = ({
  firstName,
  lastName,
  userName,
}: GetFullNameArgs): string | undefined =>
  firstName && lastName
    ? `${firstName} ${lastName}`
    : firstName
      ? firstName
      : userName;

export { getFullName };
